import { Box } from "@mui/material";
import strings from "global/constants/StringConstants";
import styles from "../ContractSearch.styles";

interface AnswerActionsProps {
  onCopy: () => void;
  onRetry: () => void;
  /** Retry is blocked while another search is running. */
  retryDisabled?: boolean;
  /** Error turns have nothing to copy. */
  showCopy?: boolean;
}

/**
 * Copy answer / Retry -- text-only buttons, as in the design. It also drew Helpful / Not helpful; those are
 * deliberately not built yet (no feedback endpoint exists — see the plan §5.9).
 */
const AnswerActions = ({
  onCopy,
  onRetry,
  retryDisabled = false,
  showCopy = true,
}: AnswerActionsProps) => {
  const copy = strings.contractSearch;
  return (
    <Box sx={styles.actionsRow}>
      {showCopy && (
        <Box
          component="button"
          type="button"
          onClick={onCopy}
          sx={styles.actionButton}
        >
          {copy.copyAnswer}
        </Box>
      )}
      <Box
        component="button"
        type="button"
        onClick={onRetry}
        disabled={retryDisabled}
        sx={styles.actionButton}
      >
        {copy.retry}
      </Box>
    </Box>
  );
};

export default AnswerActions;
